<template>
  <section>
    <h3
      v-if="calculating"
      style="margin: 3rem auto; width: 280px; font-size: 3rem; font-weight: 600;"
    >
      網頁導向中...
    </h3>
    <div v-else style="margin: 3% auto; width: 980px;">
      <div style="font-size: 3rem; font-weight: 600; text-align: center;">
        <a @click="redirectToAdmin2">重新導向</a>
      </div>
    </div>
    <b-loading :active="calculating" :is-full-page="true" :can-cancel="false" />

    <b-collapse
      class="card"
      animation="slide"
      :open="false"
      aria-id="contentIdForA11"
    >
      <template #trigger="props">
        <div
          class="card-header"
          role="button"
          aria-controls="contentIdForA11"
          :aria-expanded="props.open"
        >
          <p class="card-header-title" style="font-size: 1.6rem;">舊版DM管理</p>
          <a class="card-header-icon">
            <b-icon :icon="!props.open ? 'menu-down' : 'menu-up'"></b-icon>
          </a>
        </div>
      </template>

      <div class="card-content">
        <div class="content">
          <magazine-list :query="query" />
        </div>
      </div>
    </b-collapse>
  </section>
</template>

<script>
import MagazineList from '@/components/company/MagazineList'
import { EMPLOYEES_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'Magazines',
  components: {
    MagazineList
  },

  data() {
    const { query } = this.$route

    return {
      query: query,
      calculating: false,
      resultData: null,
      url: ''
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  },
  mounted() {
    this.redirectToAdmin2()
  },
  methods: {
    async redirectToAdmin2() {
      try {
        this.calculating = true

        const api = `${EMPLOYEES_API}/token`
        const res = await this.axios.post(api)
        this.resultData = res.data.data

        this.url = `${this.resultData.host}/fantasy?id=${this.resultData.id}&token=${this.resultData.token}&page=magazines`

        window.open(this.url)
      } catch (e) {
        this.resultData = null

        notifyService.fetch_error('jwt_token', e)
      } finally {
        this.calculating = false
      }
    }
  }
}
</script>
